<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            <tt-button-goto ttText="checklistitemitems_create_new" ttGoto="checklistitemitem" [ttGotoParms]="{ checklistitem_keyno: checkListItemKeyno, checklistitemitem_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            <tt-button ttText="checklistitemitems_reorder_alfa_automatic" (ttClick)="orderAlphabetically()" [ttSpin]="orderingAlphabetically" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
            <tt-button ttText="checklistitemitems_reorder_orderby_automatic" (ttClick)="orderByType()" [ttSpin]="orderingByType" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
        </tt-card>

        <tt-list [ttData]="itemsListCheckLists" [ttFilter]="setting.filtervalue"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="checklistitemitems_create_new" ttGoto="checklistitemitem" [ttGotoParms]="{ checklistitem_keyno: checkListItemKeyno, checklistitemitem_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button ttText="checklistitemitems_reorder_alfa_automatic" (ttClick)="orderAlphabetically()" [ttSpin]="orderingAlphabetically" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button ttText="checklistitemitems_reorder_orderby_automatic" (ttClick)="orderByType()" [ttSpin]="orderingByType" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListCheckLists" [ttFilter]="setting.filtervalue"></tt-list>
    </div>
</tt-page>
